import React, {useEffect, useState} from 'react';
import ReactMarkdown from 'react-markdown';
import Footer from '../../core/layout/footer/footer';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
    const [content, setContent] = useState('');

    // privacy-policy.md this file is present in public/ folder
    useEffect(() => {
        window.scrollTo(0, 0);
        fetch('/privacy-policy.md')
            .then(res => res.text())
            .then(setContent)
            .catch(() => setContent('# Privacy Policy\n\nContent could not be loaded.'));
    }, []);

    return (
        <div className="w-100">
            <div className="pp-page">
                <div className="pp-wrap">
                    <div className="pp-content">
                        <ReactMarkdown>{content}</ReactMarkdown>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
}

export default PrivacyPolicy;
